<template>
  <div class="flex h-screen flex-row">
    <Drawer v-if="!authStore.getIsAdmin" class="hidden h-full w-2/12 min-w-[246px] desktop:hidden" />
    <div class="flex-1 min-w-0 desktop:pt-8">
      <Header class="hidden desktop:flex desktop:pl-6 desktop:pr-10" />
      <MobileHeader class="desktop:hidden desktop:pl-6 desktop:pr-10" />
      <main class="overflow-y-auto desktop:pb-0">
        <div :class="mainContentClass">
          <slot />
        </div>
      </main>
      <Footer />
      <MobileStickyFooter />
    </div>
  </div>
</template>

<script setup lang="ts">
import MobileStickyFooter from '@/components/MobileStickyFooter.vue'
import Footer from '@/components/Footer.vue'
import { computed } from 'vue'

const authStore = useAuthStore()
const route = useRoute()

const isExplorePage = computed(() => {
  if (!route) return false
  
  const routeName = route.name?.toString() || ''
  const routePath = route.path || ''
  
  const isExplore = routeName.includes('explore') || routePath.includes('/explore')
  
  return isExplore
})

const mainContentClass = computed(() => {
  const classes = ['h-full', 'desktop:pl-6']
  if (!isExplorePage.value) {
    classes.push('desktop:pr-6')
  }
  return classes
})

</script>

<style scoped></style>
